import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Typography } from '@mui/material';

const UserOption = ({ user }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Avatar src={user?.avatar} alt={user?.firstName} sx={{ width: 28, height: 28 }}>
      {user?.firstName?.charAt(0)}
    </Avatar>
    <Typography variant="body2">{user?.firstName}</Typography>
  </Box>
);

UserOption.propTypes = {
  user: PropTypes.object,
};

export default UserOption;
